module.exports = __webpack_public_path__ + "img/BTS-Logo-Square.6a4f73f3.png";